import { createStore, applyMiddleware, compose } from 'redux';
import { routerMiddleware } from 'react-router-redux';
import { createLogger } from 'redux-logger';
import rootReducer from './reducers';
import { createEpicMiddleware } from 'redux-observable';
import { rootEpic } from './epics';
import thunk from 'redux-thunk';

const composeEnhancers = compose;

const configureStore = history => {
    const middlewares = [
        createEpicMiddleware(rootEpic),
        routerMiddleware(history),
        thunk
    ];
    if (process.env.NODE_ENV !== 'production') {
        const logger = createLogger({ collapsed: true });
        middlewares.push(logger);
    }
    return createStore(
        rootReducer,
        composeEnhancers(applyMiddleware(...middlewares))
    );
};

export default configureStore;
